import { css } from 'styled-components';
import { getThemeData } from '@hzero-front-ui/core';
var timeLineStyle = function timeLineStyle(props) {
  var _getThemeData = getThemeData(props, 'common'),
    primary6 = _getThemeData.primary6;
  return css([".ant-timeline.ant-timeline{.ant-timeline-item{&:hover{.ant-timeline-item-head{border-color:", ";color:", ";border-color:", " !important;}.ant-timeline-item-content{color:", ";}}}.ant-timeline-item-head-blue{border-color:", ";color:", ";}}"], primary6, primary6, primary6, primary6, primary6, primary6);
};
export default timeLineStyle;